import { create } from './create';

export const failedClaims = { create };
